import { MatDialog } from "@angular/material/dialog";
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChildren, } from "@angular/core";
import { Observable, Subject, } from "rxjs";
import { NotificationService } from "src/app/core/services/notification.service";
import { CommonService } from "src/app/core/services/common.service";
import { NotifierService } from "angular-notifier";
import { BaseComponent } from "src/app/shared/components/base/base.component";
import { Location } from '@angular/common';
import { map, startWith } from "rxjs/operators";
import { Message } from "src/app/core/class/message";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
import { LaborUtilizationReportService } from "src/app/core/services/labor-utilization-report.service";
import { properties } from "ng-zorro-antd";
import { WarningComponent } from "src/app/shared/components/warning/warning.component";
import { EnumCriteriaCode } from "src/app/core/constants/criteria-code";

interface IDocumentEnterprise{
  documentTemplateId: number | string | null;
  name: string;
  id: string;
  code: string;
  serviceType: string | number;
  isDraft: boolean;
  status: boolean;
}

interface IMergeFieldData{
  mergeField: any;
  isGroup?: boolean;
  startGroup?: string;
  endGroup?: string;
  children?: any;
}

interface IReportCriterionRow {
  id: number;
  order: number;
  code: string;
  name: string;
  inputType: string;
  isRequired: boolean;
  parentCode?: string;
  controlField?: FormControl;
  searchField?: FormControl;
  displayOrder?: string;
  level?: number;
  rowType: 'header' | 'subheader' | 'criterion';
  expanded?: boolean;
}

@Component({
  selector: 'app-add-labor-utilization-report',
  templateUrl: './add-labor-utilization-report.component.html',
  styleUrls: ['./add-labor-utilization-report.component.scss'],
})
export class AddLaborUtilizationReportComponent
  extends BaseComponent
  implements OnInit, AfterViewInit, OnDestroy {
  @ViewChildren("focusInput") focusInput;
  mode: string = 'create';

  addForm: FormGroup;
  listDataSource: any = [];
  listServiceType: any = [];

  displayedColumns = ["stt", "nameCriteria", "infoTemplate"];
  headerColumns = ["groupHeader"];
  listCriteria: IReportCriterionRow[] = [];
  private rawProperties: any[] = [];
  private readonly expandedGroups = new Map<string, boolean>();
  private readonly parentCodeMap = new Map<string, string>();

  listContractTemplateFilter: Observable<any>;

  listDocumentEnterprises: IDocumentEnterprise[] = [];

  dataDropDownPropertiesOrigin: IMergeFieldData[] = []
  optionsMap = new Map<number, IMergeFieldData[]>();
  optionsMapTemp = new Map<number, IMergeFieldData[]>();

  documentTypeEnterpriseIdCtrl: FormControl = new FormControl(null);
  loadingSearch: boolean = false;
  _onDestroy = new Subject<void>();

  disabledSave: boolean = false

  constructor(
    private dialog: MatDialog,
    public commonService: CommonService,
    public message: Message,
    private notifier: NotifierService,
    private router: Router,
    public toast: ToastrService,
    public route: ActivatedRoute,
    private notificationService: NotificationService,
    private activatedRouter: ActivatedRoute,
    private location: Location,
    private laborUtilizationReportService: LaborUtilizationReportService
  ) {
    super(commonService, message);
    this.notifier = notifier;
  }

  initForm() {
    this.addForm = new FormGroup({
      id: new FormControl(),
      documentTypeEnterpriseId: new FormControl(null, [Validators.required]),
      documentType: new FormControl(),
      documentTypeLD: new FormControl(),
      status: new FormControl(),
    });
    this.listContractTemplateFilter = this.documentTypeEnterpriseIdCtrl.valueChanges.pipe(
      startWith(""),
      map((value) => {
        if (!value) {
          return this.listDocumentEnterprises;
        }
        return this.listDocumentEnterprises.filter((st) => {
          const optionLabel = `${st.name}`;
          const optionCode = `${st.code}`;
          return optionLabel.toLowerCase().includes(value.trim().toLowerCase()) || optionCode.toLowerCase().includes(value.trim().toLowerCase());
        });
      })
    );
    this.addForm.controls['documentTypeEnterpriseId'].valueChanges.subscribe((res) => {
      this.resetDataWhenChangeDocumentType()
      if(res){
        this.loadDataDropDownProperties(res)
        this.fillDataFieldRelative(res)
        // this.changeValidatorExpiredDate(res)
      }
    })

    this.addForm.valueChanges.subscribe((res) => {
      this.checkIsValidForm()
    })
  }


  fillDataFieldRelative(idContractTemplate: number | string){
    let existContract = this.listDocumentEnterprises.find((documentEnterprise : any) => documentEnterprise.id == idContractTemplate)
    if(existContract){
      let existServiceTypeContract = this.listServiceType.find((document: any) => document.id == existContract.serviceType)
      if(existServiceTypeContract){
        this.addForm.controls['documentType'].setValue(existServiceTypeContract.name)
        this.addForm.controls['documentTypeLD'].setValue(existServiceTypeContract.employmentContractTerm == 'LIMITED' ? 'Xác định thời hạn' : 'Không xác định thời hạn')
      }
      this.addForm.controls['status'].setValue(existContract.status)
    }
  }

  resetDataWhenChangeDocumentType(){
    this.dataDropDownPropertiesOrigin = []
    this.addForm.controls['documentType'].setValue(null)
    this.addForm.controls['documentTypeLD'].setValue(null)
    this.addForm.controls['status'].setValue(false)
    if(this.listCriteria && this.listCriteria.length){
      this.listCriteria.forEach((item: any) => {
        if(item.controlField){
          item.controlField.patchValue(null)
        }
        this.optionsMap.set(
          item.id,
          []
        );
        this.optionsMapTemp.set(
          item.id,
          []
        )
      });
    }
  }

  changeValidatorExpiredDate(idRecord: any){
    let existContract = this.listDocumentEnterprises.find((documentEnterprise : any) => documentEnterprise.id == idRecord)
    if(existContract){
      let existServiceTypeContract = this.listServiceType.find((document: any) => document.id == existContract.serviceType)
      if(existServiceTypeContract.employmentContractTerm == 'LIMITED'){
        this.listCriteria.forEach((item: any) => {
          if(item.code == EnumCriteriaCode.ngay_ket_thuc_hdld){
            item.controlField.setValidators([Validators.required])
            item.controlField.updateValueAndValidity()
            item.isRequired = true
          }
        });
        this.listDataSource.forEach((item: any) => {
          if(item.code == EnumCriteriaCode.ngay_ket_thuc_hdld){
            item.isRequired = true
          }
        });
      }
      else{
        this.listCriteria.forEach((item: any) => {
          if(item.code == EnumCriteriaCode.ngay_ket_thuc_hdld){
            item.controlField.setValidators([])
            item.controlField.updateValueAndValidity()
            item.isRequired = false
          }
        });
        this.listDataSource.forEach((item: any) => {
          if(item.code == EnumCriteriaCode.ngay_ket_thuc_hdld){
            item.isRequired = false
          }
        });
      }
    }
  }

  async ngOnInit() {
    this.initForm();
    this.loadDataTable();
    await this.getListServiceType()
    await this.getListDocumentTypeEnterprises()
    this.activatedRouter.paramMap.subscribe((params) => {
      const id = params.get('id') ? params.get('id') : null;
      if (id) {
        this.mode = 'update';
        this.getDataById(id);
      } else {
        this.mode = 'create';
      }
    });
    window.scrollTo(0, 0);
    this.notificationService.subscribeErrorService();
  }

  ngAfterViewInit() {
    // setTimeout((_) => this.focusInput.first.nativeElement.focus());
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    this.notificationService.subscribeErrorService();
  }

  getDataById(id: string) {
    this.laborUtilizationReportService.getLaborReportById(id).subscribe((res) => {
      if (res.data) {
        if(res.data.documentTypeEnterpriseDTO){
          let existContract = this.listDocumentEnterprises.find((documentEnterprise : any) => documentEnterprise.id == res.data.documentTypeEnterpriseDTO.id)
          if(!existContract){
            this.listDocumentEnterprises.unshift(res.data.documentTypeEnterpriseDTO)
          }
        }
        this.handleDataDetail(res.data)
      } else {
        this.toast.error(
          this.message.getMessage('messages.category_not_permission')
        );
        // this.location.back();
      }
    });
  }

  handleDataDetail(data: any){
    if(data){
      this.addForm.controls['documentTypeEnterpriseId'].patchValue(data.documentTypeEnterpriseId)
      this.addForm.controls['id'].patchValue(data.id)
      if(data.contractEmploymentDocumentTypeDetails && data.contractEmploymentDocumentTypeDetails.length){
        data.contractEmploymentDocumentTypeDetails.forEach((item: any) => {
          let idxExist = this.listCriteria.findIndex((propertie: any) => propertie.code == item.code)
          if(idxExist >= 0 && this.listCriteria[idxExist] && this.listCriteria[idxExist].controlField){
            this.listCriteria[idxExist].controlField.patchValue(item.mergeField)
            this.buildOptions()
          }
        })
      }
    }
  }

  loadDataTable() {
    this.laborUtilizationReportService.getInfoProperties().subscribe((res) => {
      if (!res || !res.data) {
        return;
      }
      let dataProperties = res.data;
      dataProperties = dataProperties.filter(pro => pro.code !== EnumCriteriaCode.loai_hop_dong 
                                                && pro.code !== EnumCriteriaCode.ma_hop_dong
                                                && pro.code !== EnumCriteriaCode.ngay_bat_dau_hdld
                                                && pro.code !== EnumCriteriaCode.ngay_ket_thuc_hdld
                                                && pro.code !== EnumCriteriaCode.phuong_thuc_ky)
      this.rawProperties = dataProperties;
      this.listCriteria = this.mapDataMergeField(dataProperties) || [];
      this.rebuildTableRows();
      this.buildOptions()
    });
  }

  mapDataMergeField(data: any){
    if(!data || !data.length) return
    let dataPropertiesConvert = []
    data.filter((field: any) => field.inputType !== 'HEADER').forEach((field: any) => {
      let propertiesInfo: any = {
        ...field,
        dataDropDown: this.dataDropDownPropertiesOrigin,
        // controlField: field.isRequired ? new FormControl(null, [Validators.required]) : new FormControl(),
        controlField: new FormControl(),
        searchField: new FormControl(null),
        rowType: 'criterion'
      }
      propertiesInfo.controlField.valueChanges.subscribe((value) => {
        this.checkIsValidForm()
        this.buildOptions()
      })
      dataPropertiesConvert.push(propertiesInfo)
    });
    return dataPropertiesConvert
  }

  private rebuildTableRows() {
    if (!this.rawProperties || !this.rawProperties.length) {
      this.listDataSource = [];
      return;
    }

    const criteriaMap = new Map<string, IReportCriterionRow>();
    this.listCriteria.forEach((criterion: IReportCriterionRow) => {
      criteriaMap.set(criterion.code, criterion);
    });

    const nodes: IReportCriterionRow[] = this.rawProperties
      .map((item: any) => {
        if (item.inputType !== 'HEADER') {
          return criteriaMap.get(item.code);
        }

        return {
          ...item,
          rowType: 'header',
          expanded: this.expandedGroups.has(item.code)
            ? this.expandedGroups.get(item.code)
            : true
        } as IReportCriterionRow;
      })
      .filter((item: IReportCriterionRow) => !!item);

    const childrenMap = new Map<string, IReportCriterionRow[]>();
    this.parentCodeMap.clear();
    nodes.forEach((node: IReportCriterionRow) => {
      const parentCode = node.parentCode || '';
      this.parentCodeMap.set(node.code, parentCode);
      const children = childrenMap.get(parentCode) || [];
      children.push(node);
      childrenMap.set(parentCode, children);
    });

    const getEffectiveOrder = (node: IReportCriterionRow): number => {
      const children = childrenMap.get(node.code) || [];
      if (node.inputType !== 'HEADER' || !children.length) {
        return Number(node.order);
      }
      return Math.min(...children.map(child => getEffectiveOrder(child)));
    };

    childrenMap.forEach((children: IReportCriterionRow[]) => {
      children.sort(
        (first: IReportCriterionRow, second: IReportCriterionRow) =>
          getEffectiveOrder(first) - getEffectiveOrder(second)
      );
    });

    const rows: IReportCriterionRow[] = [];
    let runningOrder = 0;

    const appendNode = (
      node: IReportCriterionRow,
      displayOrder: string,
      level: number
    ) => {
      const isHeader = node.inputType === 'HEADER';
      rows.push({
        ...node,
        displayOrder,
        level,
        rowType: isHeader ? 'subheader' : 'criterion'
      });

      if (!isHeader) {
        return;
      }

      const children = childrenMap.get(node.code) || [];
      children.forEach((child: IReportCriterionRow, index: number) => {
        appendNode(child, `${displayOrder}.${index + 1}`, level + 1);
      });
    };

    const rootHeaders = (childrenMap.get('') || [])
      .filter((node: IReportCriterionRow) => node.inputType === 'HEADER');

    rootHeaders.forEach((root: IReportCriterionRow) => {
      rows.push({
        ...root,
        displayOrder: null,
        level: 0,
        rowType: 'header'
      });


      const children = childrenMap.get(root.code) || [];
      children.forEach((child: IReportCriterionRow) => {
        runningOrder++;
        appendNode(child, `${runningOrder}`, 1);
      });
    });

    this.listDataSource = rows;
  }

  toggleGroup(row: IReportCriterionRow) {
    row.expanded = !row.expanded;
    this.expandedGroups.set(row.code, row.expanded);
  }

  isRowVisible(row: IReportCriterionRow): boolean {
    let parentCode = row.parentCode || '';

    while (parentCode) {
      if (this.expandedGroups.get(parentCode) === false) {
        return false;
      }
      parentCode = this.parentCodeMap.get(parentCode) || '';
    }

    return true;
  }

  trackByCode(index: number, row: IReportCriterionRow): string {
    return row.code;
  }

  isHeaderRow = (_: number, row: IReportCriterionRow) => row.rowType === 'header';
  isCriterionRow = (_: number, row: IReportCriterionRow) => row.rowType !== 'header';

  onSelectionChange() {
    this.buildOptions();
  }

  private buildOptions() {
    const selectedIdSet = new Set(
      this.listCriteria
        .map((i: any) => i.controlField.value)
        .filter((id: any): id is number => id !== undefined)
    );

    this.listCriteria.forEach((item: any) => {
      this.optionsMap.set(
        item.id,
        this.dataDropDownPropertiesOrigin.filter(opt =>
          !selectedIdSet.has(opt.mergeField) || opt.mergeField === item.controlField.value
        )
      );
    });
  }

  loadDataDropDownProperties(idRecord: any) {
    if(idRecord){
      let existContract = this.listDocumentEnterprises.find((documentEnterprise : any) => documentEnterprise.id == idRecord)
      if(existContract && existContract.documentTemplateId){
        this.laborUtilizationReportService.getDataDropDownOfPropertie({templateId: existContract.documentTemplateId}).subscribe((res) => {
          if (!res || !res.data || !res.data.length || !res.data[0].file || !res.data[0].file.mergeFields) {
            return;
          }

          let dataMergeField = JSON.parse(res.data[0].file.mergeFields)
          this.dataDropDownPropertiesOrigin = dataMergeField
          this.buildOptions()
        });
      }
    }
    else{

    }
  }

  async getListServiceType() {
    const enterpriseId = localStorage.getItem('enterpriseId');
    let res = await this.laborUtilizationReportService.getServiceTypes(enterpriseId).toPromise()
    const { data } = res;
    this.listServiceType = data;
  }

  async getListDocumentTypeEnterprises() {
    this.listDocumentEnterprises = [];
    const request = {
      nameOrCode: null,
      serviceType: null,
      status: null,
      isDraft: null,
      isEmploymentContract: true,
      page: 0,
      size: 1000,
    };
    try {
      let res = await this.laborUtilizationReportService.getDocumentTypeEnterprises(request).toPromise()
      if (res.data && res.data.content.length) {
        res.data.content.forEach((item) => {
          let temp = {
            ...item
          };
          if (temp.id && temp.name) {
            this.listDocumentEnterprises.push(temp);
          }
        });

        this.listDocumentEnterprises = this.listDocumentEnterprises.sort((a, b) => {
          return a.name.localeCompare(b.name);
        });

        const isExistsMasterdata = res.data.content.find(value => {
          return this.addForm.controls.documentTypeEnterpriseId.value && this.addForm.controls.documentTypeEnterpriseId.value === value.id
        })
        if (this.addForm.controls.documentTypeEnterpriseId.value && !isExistsMasterdata) {
          this.clearData('documentTypeEnterpriseId');
        }
      } else {
        if (this.addForm.controls.documentTypeEnterpriseId.value) {
          this.clearData('documentTypeEnterpriseId');
        }
      }
      this.documentTypeEnterpriseIdCtrl.patchValue("");
    } catch (error) {
      console.log(error);
    }
  }

  btnAction(){
    // if(this.addForm.invalid || !this.checkIsValidForm()){
    //   return
    // }
    if(this.mode == 'create'){
      this.onCreate()
    }
    else{
      this.onUpdate()
    }
  }

  /**
   * Action Create
   */
  onCreate() {
    let propertiesData = this.listCriteria.map((propertie: any) => {
      let value = propertie.controlField.value
      return {
        mergeField: value,
        code: propertie.code
      }
    })
    let body = {
      documentTypeEnterpriseId: this.addForm.controls['documentTypeEnterpriseId'].value,
      contractEmploymentDocumentTypeDetails: propertiesData
    }

    this.laborUtilizationReportService
    .createConfigLinkContractTemplate(body)
    .subscribe((res) => {
      if (!res || !res.success) {
        this.toast.error(
          this.message.getMessage('labor_utilization_report.add_new_fail')
        );
        return;
      }

      this.cancel()

      this.toast.success(
        this.message.getMessage('labor_utilization_report.add_new_success')
      );
    });
  }

  /**
   * Action Update
  */
  onUpdate() {
    let propertiesData = this.listCriteria.map((propertie: any) => {
      let value = propertie.controlField.value
      return {
        mergeField: value,
        code: propertie.code
      }
    })
    let body = {
      id: this.addForm.controls['id'].value,
      documentTypeEnterpriseId: this.addForm.controls['documentTypeEnterpriseId'].value,
      contractEmploymentDocumentTypeDetails: propertiesData
    }

    this.laborUtilizationReportService
    .updateConfigLinkContractTemplate(body)
    .subscribe((res) => {
      if (!res || !res.success) {
        this.toast.error(
          this.message.getMessage('labor_utilization_report.update_fail')
        );
        return;
      }

      this.cancel()

      this.toast.success(
        this.message.getMessage('labor_utilization_report.update_success')
      );
    });
  }

  cancel(isConfirm: boolean = false) {
    if (isConfirm) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '370px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          setTimeout(() => {
            this.router.navigate(['/home-enterprise/labor-utilization-report'], {
              relativeTo: this.route,
              queryParams: {
                currentTab: 1,
              },
              queryParamsHandling: 'merge',
              replaceUrl: true,
              skipLocationChange: false
            });
          },
            500
          )
        }
        dialogRe.close();
      });
    } else {
      setTimeout(() => {
        this.router.navigate(['/home-enterprise/labor-utilization-report'], {
          relativeTo: this.route,
          queryParams: {
            currentTab: 1,
          },
          queryParamsHandling: 'merge',
          replaceUrl: true,
          skipLocationChange: false
        });
      },
        500
      )
    }
  }

  clearData(field: string) {
    this.addForm.get(field).patchValue(null);
  }

  clearDataPropertie(row: IReportCriterionRow){
    if(row && row.controlField){
      row.controlField.setValue(null)
      this.buildOptions()
    }
  }

  focusOut(field: string) {
    const value = this.addForm.get(field).value
      ? this.addForm.get(field).value.trim()
      : null;
    this.addForm.get(field).patchValue(value);
  }

  displayTooltip(data, index, className) {
    const elmsSpan = document.getElementsByClassName(className);
    const elmsCell = document.getElementsByClassName("cell");
    const span = elmsSpan.item(index);
    const cell = elmsCell.item(index);

    if (span && cell && span.scrollWidth > cell.scrollWidth) {
      return data;
    } else {
      return null;
    }
  }

  checkIsValidForm(){
    let isInValidForm = this.addForm.invalid
    let isValidFormChild = true
    // this.listCriteria.forEach((data: any) => {
    //   if(data.isRequired && !data.controlField.value){
    //     isValidFormChild = false
    //   }
    // });
    this.disabledSave = !isInValidForm && isValidFormChild
  }

  filterDropDown(event: any, selectedRow: IReportCriterionRow){
    const searchValue = event || '';
    const selectedIdSet = new Set(
      this.listCriteria
        .map((i: any) => i.controlField.value)
        .filter((id: any): id is number => id !== undefined)
    );

    this.listCriteria.forEach((item: any) => {
      if(selectedRow && selectedRow.id === item.id){
        this.optionsMap.set(
          item.id,
          this.dataDropDownPropertiesOrigin.filter(opt =>
            (!selectedIdSet.has(opt.mergeField) || opt.mergeField === item.controlField.value) &&
            this.commonService.extractUnicode(opt.mergeField).toLowerCase().includes(this.commonService.extractUnicode(searchValue).trim().toLowerCase())
          )
        );
      }
    });
  }

  filterMergeFieldOption = (searchValue: string, option: any): boolean => {
    const keyword = this.commonService
      .extractUnicode(searchValue || '')
      .trim()
      .toLowerCase();
    const label = this.commonService
      .extractUnicode(String(option.nzLabel || ''))
      .toLowerCase();

    return label.includes(keyword);
  };
}
